import { createReducer, on } from '@ngrx/store';
import { createErrorState, createLoadingState, createSuccessState, createInitialDataState } from '../app/app.models';
import * as MessagingActions from './messaging.actions';
import { initialMessagingState } from './messaging.state';

export const messagingReducer = createReducer(
  initialMessagingState,
  // Load Messages
  on(MessagingActions.loadMessages, (state) => ({
    ...state,
    messages: createLoadingState(state.messages),
  })),
  on(MessagingActions.loadMessagesSuccess, (state, { collection }) => ({
    ...state,
    messages: createSuccessState(collection),
  })),
  on(MessagingActions.loadMessagesFailure, (state, { error }) => ({
    ...state,
    messages: createErrorState(error, null),
  })),

  // Load Message Content
  on(MessagingActions.loadMessageContent, (state, { id }) => ({
    ...state,
    messageContent: {
      ...state.messageContent,
      [id]: createLoadingState(state.messageContent[id] || createInitialDataState(null)),
    },
  })),
  on(MessagingActions.loadMessageContentSuccess, (state, { id, content }) => ({
    ...state,
    messageContent: {
      ...state.messageContent,
      [id]: createSuccessState(content),
    },
  })),
  on(MessagingActions.loadMessageContentFailure, (state, { id, error }) => ({
    ...state,
    messageContent: {
      ...state.messageContent,
      [id]: createErrorState(error, null),
    },
  })),

  // Get Attachment
  on(MessagingActions.getAttachment, (state, { messageHeaderId, attachmentFileName }) => {
    const key = `${messageHeaderId}::${attachmentFileName}`;
    return {
      ...state,
      attachments: {
        ...state.attachments,
        [key]: createLoadingState(state.attachments[key] || createInitialDataState(null)),
      },
    };
  }),
  on(MessagingActions.getAttachmentSuccess, (state, { messageHeaderId, attachmentFileName, blob }) => {
    const key = `${messageHeaderId}::${attachmentFileName}`;
    return {
      ...state,
      attachments: {
        ...state.attachments,
        [key]: createSuccessState(blob),
      },
    };
  }),
  on(MessagingActions.getAttachmentFailure, (state, { messageHeaderId, attachmentFileName, error }) => {
    const key = `${messageHeaderId}::${attachmentFileName}`;
    return {
      ...state,
      attachments: {
        ...state.attachments,
        [key]: createErrorState(error, null),
      },
    };
  }),

  // Resend Messages (batch)
  on(MessagingActions.resendMessages, (state) => ({
    ...state,
    resendMessages: createLoadingState(state.resendMessages || createInitialDataState(null)),
  })),
  on(MessagingActions.resendMessagesSuccess, (state, { response }) => ({
    ...state,
    resendMessages: createSuccessState(response),
  })),
  on(MessagingActions.resendMessagesFailure, (state, { error }) => ({
    ...state,
    resendMessages: createErrorState(error, null),
  })),

  // Resend Single Message
  on(MessagingActions.resendSingleMessage, (state, { messageHeaderId }) => ({
    ...state,
    resendSingleMessage: {
      ...state.resendSingleMessage,
      [messageHeaderId]: createLoadingState(state.resendSingleMessage[messageHeaderId] || createInitialDataState(null)),
    },
  })),
  on(MessagingActions.resendSingleMessageSuccess, (state, { messageHeaderId, response }) => ({
    ...state,
    resendSingleMessage: {
      ...state.resendSingleMessage,
      [messageHeaderId]: createSuccessState(response),
    },
  })),
  on(MessagingActions.resendSingleMessageFailure, (state, { messageHeaderId, error }) => ({
    ...state,
    resendSingleMessage: {
      ...state.resendSingleMessage,
      [messageHeaderId]: createErrorState(error, null),
    },
  })),
);
